var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2C3 0.89543 3.89543 0 5 0H12C13.1046 0 14 0.89543 14 2V13.0016C14 14.1082 13.1025 15 12 15H5C3.89543 15 3 14.1046 3 13V2ZM6 2C5.44772 2 5 2.44772 5 3V12C5 12.5523 5.44772 13 6 13H11C11.5523 13 12 12.5523 12 12V3C12 2.44772 11.5523 2 11 2H6ZM1 5C1.55228 5 2 5.44772 2 6V15C2 15.5523 2.44772 16 3 16H11C11.5523 16 12 16.4477 12 17C12 17.5523 11.5523 18 11 18H2C0.895431 18 0 17.1046 0 16V6C0 5.44772 0.447715 5 1 5ZM7 3C6.44772 3 6 3.44772 6 4C6 4.55228 6.44772 5 7 5H10C10.5523 5 11 4.55228 11 4C11 3.44772 10.5523 3 10 3H7ZM6 7C6 6.44772 6.44772 6 7 6H10C10.5523 6 11 6.44772 11 7C11 7.55228 10.5523 8 10 8H7C6.44772 8 6 7.55228 6 7ZM7 9C6.44772 9 6 9.44771 6 10C6 10.5523 6.44772 11 7 11H8C8.55228 11 9 10.5523 9 10C9 9.44771 8.55229 9 8 9H7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.4839f33e.svg";
export { ForwardRef as ReactComponent };